module.exports = __webpack_public_path__ + "img/news.e783c2fe.jpeg";